import { Box, ListItemButton, Tooltip } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import RssFeedIcon from '@mui/icons-material/RssFeed';

import DeviceName from './DeviceName';
import SensorStateIcon from './SensorState';
import SignalLevel from './SignalLevel';
import BatteryLevel, { BatteryInfo } from './BatteryLevel';
import { SensorState, SensorType } from '../../../types/sensor';
import { DeviceType } from '../../../types/device';
import { LogConfig } from '../../../types/log-config';
import { getDeviceStatusColor } from '../../../utils/device-status';

export interface DeviceViewProps {
    deviceType: DeviceType;
    deviceId: number;
    sensorType: SensorType;
    sensorId: number;
    lastTransaction: string;
    logConfig: LogConfig;
    nodeId?: number;
    battery?: BatteryInfo;
    rssi?: number;
    sensorState?: SensorState;
    selected?: boolean;
    depth?: number;
    actions?: React.ReactNode;
    onClick: (deviceId: number) => void;
}

export default function DeviceView({
    deviceType,
    deviceId,
    sensorType,
    sensorId,
    lastTransaction,
    logConfig,
    nodeId,
    battery,
    rssi,
    sensorState,
    selected,
    depth = 0,
    actions,
    onClick,
}: DeviceViewProps) {
    const statusColor = getDeviceStatusColor(lastTransaction, logConfig);
    const navigate = useNavigate();

    return (
        <ListItemButton
            onClick={() => onClick(deviceId)}
            selected={selected}
            id={`sidebar-device-${deviceId}`}
            sx={{
                borderRadius: 1,
                py: 0.5,
                pl: 1 + depth * 2,
                pr: 1.5,
            }}
        >
            <RssFeedIcon sx={{ fontSize: 14, mr: 0.5, flexShrink: 0 }} />
            <DeviceName deviceType={deviceType} id={deviceId} />
            <Box sx={{ flex: 1 }} />
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, flexShrink: 0 }}>
                <SensorStateIcon sensorType={sensorType} sensorId={sensorId} sensorState={sensorState} />
                {rssi !== undefined && <SignalLevel rssi={rssi} size={18} />}
                {battery !== undefined && <BatteryLevel battery={battery} size={18} />}
                <Tooltip title="Статистика устройства">
                    <Box
                        component="button"
                        onClick={(e) => {
                            e.stopPropagation();
                            navigate(`/device/${deviceId}`, { state: { nodeId } });
                        }}
                        sx={{
                            width: 16,
                            height: 16,
                            p: 0,
                            border: 'none',
                            borderRadius: '50%',
                            backgroundColor: 'transparent',
                            flexShrink: 0,
                            ml: 0.5,
                            cursor: 'pointer',
                            display: 'inline-flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}
                        aria-label="Статистика устройства"
                    >
                        <svg width="16" height="16" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="12" cy="12" r="11" fill={statusColor} />
                            <text
                                x="12"
                                y="17"
                                textAnchor="middle"
                                fontFamily="Georgia, 'Times New Roman', serif"
                                fontWeight="bold"
                                fontStyle="italic"
                                fontSize="14"
                                fill="#fff"
                            >
                                i
                            </text>
                        </svg>
                    </Box>
                </Tooltip>
            </Box>
            {actions && (
                <Box sx={{ ml: 0.5, flexShrink: 0 }} onClick={(e) => e.stopPropagation()}>
                    {actions}
                </Box>
            )}
        </ListItemButton>
    );
}
